import { render, staticRenderFns } from "./myDiscussionList.vue?vue&type=template&id=1423edc4&scoped=true"
import script from "./myDiscussionList.vue?vue&type=script&lang=js"
export * from "./myDiscussionList.vue?vue&type=script&lang=js"
import style0 from "./myDiscussionList.vue?vue&type=style&index=0&id=1423edc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1423edc4",
  null
  
)

export default component.exports